module.exports = __webpack_public_path__ + "static/media/incoming-video-call.af8271c2.svg";